import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../services/i18nService';
import styles from './keyboardHelpAndPrompt.scss';
import Prompt from '../interactions/Prompt';

class KeyboardHelpAndPrompt extends React.PureComponent {
    static propTypes = {
        captionKey: PropTypes.string.isRequired,
        model: PropTypes.object.isRequired,
        showAccessibilityHelpers: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.state = { open: false };
    }

    toggleOpenState = () => {
        this.setState({ open: !this.state.open });
    };

    render() {
        const { captionKey, model, showAccessibilityHelpers } = this.props;
        const textStyle = `${styles.keyboardHelpText} ${this.state.open ? '' : 'hidden'}`;
        const buttonStyle = `${styles.button} ${this.state.open ? styles.active : ''}`;
        return (
            <div className={`${styles.keyboardHelpWrapper} kb-help-and-prompt-wrapper`}>
                <div className={styles.promptAndButtonRow}>
                    <Prompt model={model.prompt} extraClassNames={styles.prompt} />
                    { showAccessibilityHelpers ?
                        <button
                            aria-label={t('interactions.keyboardHelpButtonLabel')}
                            className={`${buttonStyle} keyboard-help-button`}
                            type="button"
                            onClick={this.toggleOpenState}
                            data-type="accessibility-helper"
                        >
                            <i className="fa fa-keyboard-o" aria-hidden="true" />
                            { t('interactions.keyboardHelp') }
                        </button>
                        : null
                    }
                </div>
                <div
                    role="alert"
                    className={textStyle}
                    dangerouslySetInnerHTML={{ __html: t(captionKey) }}
                />
            </div>
        );
    }
}

export default KeyboardHelpAndPrompt;
